import React, { useEffect, useState } from 'react'

import { api_gateway } from '../../../conexoes/api.js'
import { useGlobal } from '../../../stores/useGlobal.js'
import MensagemErro from '../../componentesModais/mensagens/mensagemErro.js'
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso.js'
import Checkbox from '../../Mantine/Checkbox'
import Modal from '../../Mantine/Modal/index.jsx'

import * as S from './styles.js'

const ALERTAS = {
  padrao: {
    open: false,
    mensagem: '',
    titulo: ''
  },
  sucesso: {
    titulo: 'Sucesso',
    open: true,
    mensagem: 'Bloqueio por consumo percentual alterado com sucesso.'
  },
  erro: {
    titulo: 'Erro',
    open: true,
    mensagem:
      'Falha ao alterar bloqueio por consumo percentual. Tente novamente.'
  }
}

export default function BloqueioPorConsumoPercentual({
  codigoCliente,
  bloqueioPorConsumo,
  onFinish
}) {
  const { setMostrarAcao, setIsLoadingGlobal } = useGlobal()
  const [bloquear, setBloquear] = useState(false)
  const [alerta, setAlerta] = useState(ALERTAS.padrao)

  useEffect(() => {
    setBloquear(bloqueioPorConsumo)
  }, [bloqueioPorConsumo, codigoCliente])

  const handleSubmit = async () => {
    setIsLoadingGlobal(true)
    const payload = {
      fl_bloquear_ao_exceder: bloquear ? 1 : 0,
      cd_pav_cliente: codigoCliente
    }
    api_gateway
      .post('/m1/alterar/cliente_excedente', payload)
      .then(() => {
        setAlerta(ALERTAS.sucesso)
      })
      .catch(() => {
        setAlerta(ALERTAS.erro)
      })
      .finally(() => {
        setIsLoadingGlobal(false)
      })
  }

  const handleClose = (isSucess = false) => {
    setMostrarAcao(undefined)

    if (isSucess) onFinish(bloquear ? 1 : 0)
  }

  if (alerta.open) {
    return alerta.titulo === 'Sucesso' ? (
      <MensagemSucesso
        handleMensagemSucesso={() => handleClose(true)}
        mensagemTitulo={alerta.titulo}
        mensagemParagrafo1={alerta.mensagem}
        mensagemBotao="Fechar"
      />
    ) : (
      <MensagemErro
        handleMensagemErro={() => handleClose()}
        mensagemTitulo={alerta.titulo}
        mensagemParagrafo1={alerta.mensagem}
        mensagemBotao="Fechar"
        centralizarBotao
      />
    )
  }

  return (
    <Modal
      titulo="Bloqueio por consumo percentual"
      width="555px"
      opened
      close={handleClose}
      onConfirm={handleSubmit}
    >
      <S.ContentModal>
        <Checkbox
          id="receberEmails"
          label={
            <div>
              Bloquear linhas compartilhadas ao exceder percentual{' '}
              <S.SpanCinza>(500%)</S.SpanCinza>.
            </div>
          }
          checked={bloquear}
          onChange={(event) => setBloquear(event.currentTarget.checked)}
        />
      </S.ContentModal>
    </Modal>
  )
}
